import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { ReactElement } from 'react'
import { ColumnDef, SortingState } from '@tanstack/react-table'
import { Button } from 'app/components/ui/button'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import SimpleTable from 'app/components/table/SimpleTable'
import { FilterableColumn } from 'app/filter.utils'
import type { UserJson } from 'app/types/entities'

export type UsersIndexShadcnComponentProps = {
  users: { hits: UserJson[]; total: number } | undefined
  columns: ColumnDef<UserJson, any>[]
  filters: FilterableColumn[]
  initialSort?: SortingState
  canEditUser: boolean
  userIsOrg: boolean
  isSuperUser: boolean
  inWorkspace: boolean
  onSearchValueChange?: (value: string) => void
}

export const UsersIndexShadcnComponent = observer(function UsersIndexShadcnComponent({
  users,
  columns,
  filters,
  initialSort,
  canEditUser,
  onSearchValueChange,
}: UsersIndexShadcnComponentProps): ReactElement {
  return (
    <PageScroll
      variant="table"
      header={
        <PageHeaderComponent
          title="Users"
          primaryButtonSlot={
            canEditUser ? (
              <Link to="new">
                <Button variant="primary" size="lg">
                  + Add User
                </Button>
              </Link>
            ) : undefined
          }
        />
      }
    >
      <SimpleTable
        data={users?.hits}
        columns={columns}
        filterableColumns={filters}
        showColumnOrdering
        enableExport={false}
        initialSort={initialSort}
        onSearchValueChange={onSearchValueChange}
        edgePadded
      />
    </PageScroll>
  )
})
